(() => {
  if (window.__lgdProductImageGalleryLoaded) return;
  window.__lgdProductImageGalleryLoaded = true;

  const selector = '[data-product-image-gallery]';

  function initialise(root) {
    if (!root || root.dataset.galleryInitialised === 'true') return;
    root.dataset.galleryInitialised = 'true';

    const mainImage = root.querySelector('[data-gallery-main-image]');
    const thumbnails = Array.from(root.querySelectorAll('[data-gallery-thumbnail]'));
    if (!mainImage || thumbnails.length === 0) return;

    let activeIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('active')));

    const select = (index) => {
      activeIndex = (index + thumbnails.length) % thumbnails.length;
      const active = thumbnails[activeIndex];

      mainImage.src = active.dataset.gallerySrc;
      mainImage.srcset = active.dataset.gallerySrcset || '';
      mainImage.alt = active.dataset.galleryAlt || '';

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('active', isActive);
        thumbnail.setAttribute('aria-pressed', String(isActive));
      });
    };

    const selectPackImage = (tier, purchaseType) => {
      if (root.dataset.galleryPackSync !== 'true') return;

      const galleryKey = root.getAttribute(`data-gallery-pack-${tier}-key`);
      let index = -1;

      if (root.dataset.galleryPurchaseTypeSync === 'true' && purchaseType === 'onetime') {
        const onetimeKey = root.getAttribute(`data-gallery-pack-${tier}-onetime-key`);
        if (onetimeKey && onetimeKey !== 'same_as_subscription') {
          index = thumbnails.findIndex((thumbnail) => thumbnail.dataset.galleryKey === onetimeKey);
        }
      }

      if (index < 0 && galleryKey) {
        index = thumbnails.findIndex((thumbnail) => thumbnail.dataset.galleryKey === galleryKey);
      }
      if (index >= 0) select(index);
    };

    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => select(index)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(activeIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(activeIndex + 1));

    const sectionRoot = root.closest('.shopify-section');
    sectionRoot?.addEventListener('lgd:product-pack-change', (event) => {
      selectPackImage(event.detail?.tier, event.detail?.purchaseType);
    });
    sectionRoot?.addEventListener('lgd:product-purchase-type-change', (event) => {
      if (root.dataset.galleryPurchaseTypeSync !== 'true') return;
      selectPackImage(event.detail?.tier, event.detail?.purchaseType);
    });

    const selectedPackInput = sectionRoot?.querySelector(
      '[data-product-purchase-items-block] [data-ppi-pack-option] input[type="radio"]:checked'
    );
    const selectedPack = selectedPackInput?.closest('[data-ppi-pack-option]');
    const selectedPurchaseType = sectionRoot?.querySelector(
      '[data-product-purchase-items-block] [data-purchase-type-input]:checked'
    )?.value;
    if (selectedPack) selectPackImage(selectedPack.dataset.ppiPackTier, selectedPurchaseType);
  }

  const initialiseAll = (scope = document) => {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
